import { render, staticRenderFns } from "./LifeExpectancyModal.vue?vue&type=template&id=6967e164&scoped=true&"
import script from "./LifeExpectancyModal.vue?vue&type=script&lang=js&"
export * from "./LifeExpectancyModal.vue?vue&type=script&lang=js&"
import style0 from "./LifeExpectancyModal.vue?vue&type=style&index=0&id=6967e164&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967e164",
  null
  
)

export default component.exports